
class TableActionsSelectors {

    getComponentSelector()
    {
        return '.table_actions_component';
    }


    getActionsSelectSelector()
    {
        return '.table_actions_select_component';
    }

    getActionsEmailSelector()
    {
        return '.table_actions_email_component';
    }

    getActionsEmailHolderSelector()
    {
        return '.action_email_holder_component';
    }

}

